import { Loader } from 'BreetComponents';
import { useModalApi } from 'BreetHooks';
import { useGetTeamMembersByIdQuery } from 'BreetRedux';

import Child from './Child';

const DialogInviteTeamMember = () => {
	const modalApis = useModalApi();
	const { getModalProps } = modalApis;

	const modalProps = getModalProps('inviteTeamMember');
	const modalMetadata = modalProps?.metadata as { intent?: 'invite' | 'view'; teamMemberId?: string } | undefined;

	const { data: teamMemberData, isLoading: isTeamMemberLoading } = useGetTeamMembersByIdQuery(modalMetadata?.teamMemberId ?? '', {
		skip: !modalMetadata?.teamMemberId && modalMetadata?.intent === 'invite',
	});

	if (isTeamMemberLoading) {
		return <Loader />;
	}

	return (
		<Child
			teamMemberData={teamMemberData}
			modalApis={modalApis}
		/>
	);
};

export default DialogInviteTeamMember;
